// Global Enums
import {
  ChampionshipDocumentStatus,
  RegattaDocumentStatus,
  RegattaLogAction,
  RegattaStatus,
} from 'common.data';

export const regattaStatusClass: Record<RegattaStatus, string> = {
  [RegattaStatus.canceled]: 'bg-danger',
  [RegattaStatus.ended]: 'bg-light text-dark',
  [RegattaStatus.new]: 'bg-info',
  [RegattaStatus.ongoing]: 'bg-warning text-dark',
  [RegattaStatus.upcoming]: 'bg-success',
};

export const regattaLogActionClass: Record<RegattaLogAction, string> = {
  [RegattaLogAction.created]: 'bg-success',
  [RegattaLogAction.deleted]: 'bg-danger',
  [RegattaLogAction.updated]: 'bg-warning',
};

export const regattaDocumentStatusClass: Record<RegattaDocumentStatus, string> = {
  [RegattaDocumentStatus.confirmed]: 'bg-success',
  [RegattaDocumentStatus.pending]: 'bg-warning text-dark',
  [RegattaDocumentStatus.rejected]: 'bg-danger',
};

export const championshipDocumentStatusClass: Record<ChampionshipDocumentStatus, string> = {
  [ChampionshipDocumentStatus.confirmed]: 'bg-success',
  [ChampionshipDocumentStatus.pending]: 'bg-warning text-dark',
  [ChampionshipDocumentStatus.rejected]: 'bg-danger',
};
